import { chakra, Box, Button } from '@stockx/ui';

export const StyledUserGeneratedContentTile = chakra(Box, {
  baseStyle: {
    position: 'relative',
    width: { base: '216px', md: '296px' },
    height: { base: '216px', md: '296px' },
    div: {
      position: 'absolute',
      display: 'none',
      top: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(15, 15, 15, 0.5)',
      color: 'neutral.white',
    },
    _hover: {
      cursor: 'pointer',
      div: {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        button: {
          width: 'clamp(114px, 40%, 200px)',
        },
        p: {
          position: 'absolute',
          bottom: 2,
        },
      },
    },
  },
});

export const UserGeneratedContentTileShopNowButton = chakra(Button, {
  baseStyle: {
    color: 'neutral.white',
    borderColor: 'neutral.white',
    variant: 'secondary',
    _hover: {
      backgroundColor: 'neutral.white',
      color: 'black',
    },
  },
});
